var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtrSurrenderedStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27148 0.46875C1.27148 0.209867 1.06162 0 0.802734 0C0.543851 0 0.333984 0.209867 0.333984 0.46875V9.53125C0.333984 9.79013 0.543851 10 0.802734 10C1.06162 10 1.27148 9.79013 1.27148 9.53125V6.78659L2.30737 6.56851C3.21185 6.37809 4.15429 6.50435 4.97675 6.92612C6.12914 7.5171 7.46677 7.63468 8.70459 7.25381L10.0031 6.85427C10.1998 6.79375 10.334 6.61203 10.334 6.40625V1.09375C10.334 0.952485 10.2703 0.818755 10.1606 0.729748C10.0509 0.640742 9.9069 0.605952 9.76867 0.635053L8.28132 0.948179C7.40593 1.13247 6.49557 1.05352 5.66497 0.721285L5.35117 0.595765C4.34873 0.194787 3.25002 0.0995053 2.19351 0.321928L1.27148 0.516039V0.46875Z",
    fill: "#0E7241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtrSurrenderedStatusIcon);
export default __webpack_public_path__ + "static/media/etr-surrendered-status-icon.936015f20d02a900ab174da70be116a3.svg";
export { ForwardRef as ReactComponent };